import client from "./client";

const BranchService = {};

BranchService.get = function () {
  return client.get("/branch");
};

BranchService.getCurrent = function () {
  return client.get("/branch/current");
};

BranchService.update = function (branchId, data) {
  return client.put(`/branch/${branchId}`, data);
};

BranchService.create = function (data) {
  return client.post(`/branch`, data);
};

BranchService.changeBranch = function (branchId) {
  return client.post(`/branch/change-branch/${branchId}`);
};

BranchService.getCounters = function () {
  return client.get("/branch/counters");
};

BranchService.resetCounter = function (command) {
  return client.put(`/branch/reset-counter/${command}`, {});
};

BranchService.getSmsBlackList = function (type) {
  return client.get("/branch/sms-blacklist", {
    type,
  });
};

BranchService.addSmsBlackList = function (data) {
  return client.post(`/branch/sms-blacklist`, data);
};

BranchService.removeSmsBlackList = function (id) {
  return client.del(`/branch/sms-blacklist/${id}`);
};

BranchService.updateSmsSettings = function (branchId, data) {
  return client.put(`/branch/${branchId}/sms-settings`, data);
};

BranchService.sendBranchSms = function (branchId, data) {
  return client.post(`/branch/${branchId}/send-sms`, data);
};

export default BranchService;
